// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1AccountAppSchema = z.object({
  app_id: z.number().int().describe("Unique numeric identifier for the app"),
  id: z.coerce.string().describe("App name identifier"),
  display_name: z.coerce.string().describe("Display name of the app"),
  description: z.coerce.string().describe("Description of the app").nullish(),
  layout: z.optional(z.coerce.string().describe("Layout type for the app")),
  integrated: z.boolean().describe("Whether the app is currently integrated"),
  pending: z.boolean().describe("Whether integration is pending"),
  disconnected_integrations_count: z.number().int().describe("Number of disconnected integrations"),
  connected_integrations_count: z.number().int().describe("Number of active integrations"),
  first_created_at: z.string().datetime().describe("When first integration was created").nullish(),
  last_imported_at: z.string().datetime().describe("When data was last imported").nullish(),
  last_exported_at: z.string().datetime().describe("When data was last exported").nullish(),
  platforms: z.optional(z.array(z.coerce.string()).describe("Supported platforms")),
  summary: z.optional(z.coerce.string().describe("Short summary of the app")),
  provider: z.optional(z.coerce.string().describe("Provider name")),
  provider_url: z.optional(z.coerce.string().describe("Provider URL")),
  screenshots: z.array(z.coerce.string()).describe("Screenshot URLs").nullish(),
  logo_path: z.optional(z.coerce.string().describe("Path to logo")),
  logo_url: z.optional(z.coerce.string().describe("Full URL to logo")),
  authorize_url: z.coerce.string().describe("URL to authorize this app"),
  authorize_full_url: z.coerce.string().describe("Full authorization URL"),
  connected_apps_url: z.coerce.string().describe("URL to view connected apps"),
  category: z.optional(z.coerce.string().describe("App category")),
  scope: z.optional(z.coerce.string().describe("Integration scope (user or account)")),
  html: z.coerce.string().describe("HTML content for the app").nullish(),
  import_support: z.optional(z.array(z.coerce.string()).describe("List of supported import types")),
  uninstall_url: z.coerce.string().describe("URL for uninstall instructions").nullish(),
  support_url: z.optional(z.coerce.string().describe("Support URL")),
  premium: z.boolean().describe("Whether this is a premium integration"),
  unlimited_plus: z.boolean().describe("Whether this requires unlimited plus plan"),
  feature_requirements: z.optional(z.array(z.coerce.string()).describe("Required features")),
  can_connect: z.boolean().describe("Whether current user can connect this app"),
  is_importing: z.optional(z.boolean().describe("Whether currently importing data")),
});
